import React, { useState } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import CallIcon from '@material-ui/icons/Call';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import {useDispatch, useSelector} from "react-redux";
import Utils from "../../../helpers/Utils";
import {setCallEnvironment} from "../../../reducers/globalDialerV2/globalDialerSlice";
import {useHistory} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    callWrapper: {
        color: '#fff',
        backgroundColor: "#222241",

        "& .headerSection": {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '0px 12px 12px 12px',
            borderBottom: '1px solid #e5e8ef',

            "& .headerSectionLeft": {
                display: 'flex',
                alignItems: 'center',
                gap: 8,

                '& .MuiSvgIcon-root': {
                    color: '#fff !important'
                }
            }
        },

        "& .contentSection": {
            padding: "20px 12px",

            "& .contactInfo": {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }
        },

        '& .footerSection': {
            '& svg.transferIcon': {
                color: '#fff !important',
            }
        }
    },
    defaultButton: {
        backgroundColor: "#fff !important",
        color: 'var(--dark_blue) !important',
        fontSize: '13px !important',
        textTransform: 'capitalize !important',
        fontWeight: "600 !important",
        padding: '6px 16px !important',
        "&:hover, &:focus": {
            backgroundColor: "#fff !important",
            color: 'var(--dark_blue) !important',
        }
    },
    declineButton: {
        backgroundColor: "#f50057 !important",
        color: '#fff !important',
        fontSize: '14px !important',
        textTransform: 'capitalize !important',
        fontWeight: "600 !important",
        padding: '6px 8px !important',
        "&:hover, &:focus": {
            backgroundColor: "#f50057 !important",
            color: '#fff !important',
        }
    }, 
    transferButton: {
        backgroundColor: "#3D50FF !important",
        color: '#fff !important',
        textTransform: 'capitalize',
        padding: '7px 0px !important',
        "&:hover, &:focus": {
            backgroundColor: "#3D50FF !important",
            color: '#fff !important',
        }
    },
    answerButton: {
            fontSize: '14px !important',
            textTransform: 'capitalize !important',
            fontWeight: "600 !important",
            padding: '6px 8px !important',
            backgroundColor: "#34F28B !important",
            color: "#212140 !important",
            borderRadius: "4px !important",
            "&:hover, &:focus": {
                backgroundColor: "#34F28B !important",
                color: "#212140 !important",
            },
            "& svg": {
                color: "#212140 !important",
            },
            "&.active": {
                backgroundColor: "#34F28B !important",
                color: "#212140 !important",
                },

            "&.MuiButton-contained.Mui-disabled": {
                backgroundColor: "rgba(0, 0, 0, 0.12) !important",
            }
        },
}));


const IncomingCall = ({ acceptCall, rejectCall }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {callEnvironment} = useSelector((state)=>(state.globalDialerV2));
    const classes = useStyles();
    const [hasClickedViewContact, setHasClickedViewContact] = useState(false);

    const handleCallTransfer = () => {
        dispatch(setCallEnvironment({
            isTransferring: true
        }));
    };

    const handleRedirectContactDetails = () => {
        if (callEnvironment.incomingCallConnection && callEnvironment.incomingCallContact?.id){
            setHasClickedViewContact(true);
            history.push(`/contacts/${callEnvironment.incomingCallContact.id}`);
        }
    };

    const isNewContact = () => {
        try{
            const contactId = callEnvironment.incomingCallContact?.id;

            return !Number(contactId);
        }catch (err){
            return true;
        }
    };

    const renderCallerInfo = () => {
        const view = [];

        if (callEnvironment.callInfo.callerName && !Utils.isNumeric(callEnvironment.callInfo.callerName)){
            view.push(<h6 style={{ fontSize: 15, margin: "0px 4px 4px" }}>{callEnvironment.callInfo.callerName}</h6>);
        }else {
            view.push(<h6 style={{ fontSize: 15, margin: "0px 4px 4px" }}>Unknown</h6>);
        }

        if (callEnvironment.callInfo.callerNumber){
            view.push(<div style={{ fontSize: 12 }}>{Utils.formatNumber(callEnvironment.callInfo.callerNumber)}</div>);
        }

        return (
            <div>
                {view}
            </div>
        );
    };

    return (
        <div className={classes.callWrapper}>
            <div  className='headerSection'>
                <div className='headerSectionLeft'>
                    <CallIcon />

                    <h6 style={{ margin: 0, fontSize: '16px' }}>Incoming Call...</h6>
                </div>
            </div>

            <div className='contentSection'>
                <div className='contactInfo'>
                    {renderCallerInfo()}

                    {
                        ( !isNewContact() && 
                         !hasClickedViewContact) &&
                        <Button
                            variant='contained'
                            className={classes.defaultButton}
                            startIcon={<AccountCircleIcon />}
                            disableElevation
                            onClick={handleRedirectContactDetails}
                        >
                            View Contact
                        </Button>
                    }
                </div>
            </div>

            <div className='footerSection' style={{ display: 'flex', alignItems: 'center', gap: 8, padding: 12 }}>
                <Button 
                    variant='contained' 
                    className={classes.answerButton} 
                    disableElevation
                    fullWidth
                    onClick={acceptCall}
                >
                    Answer
                </Button>
                <Button 
                    variant='contained' 
                    className={classes.declineButton}
                    disableElevation
                    fullWidth
                    onClick={rejectCall}
                >
                    Decline
                </Button>
                
                <Button 
                    variant='contained' 
                    className={classes.transferButton}
                    disableElevation
                    fullWidth
                    onClick={handleCallTransfer}
                >
                    <SyncAltIcon className={'transferIcon'}/>
                </Button>
                
            </div>
        </div>
    );
};

export default IncomingCall;